import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface SplitViewIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number | string;
}

const SplitViewIcon: React.FC<SplitViewIconProps> = ({ strokeWidth = 2, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 50 50" className="sx-icon-split-view">
    {/* Outer square */}
    <path
      d="M8 8 H42 V42 H8 Z"
      fill="none"
      stroke={props.color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinecap="butt"
      strokeLinejoin="miter"
    />

    {/* Horizontal divider */}
    <path
      d="M8 25 H42"
      fill="none"
      stroke={props.color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinecap="butt"
      strokeLinejoin="miter"
    />
  </SvgIcon>
);

export default SplitViewIcon;

